import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdminPanelRoutingModule } from './admin-panel-routing.module';
import { BanksComponent } from '../admin/banks/banks.component';
import { AppointmentStatusesComponent } from '../admin/appointment-statuses/appointment-statuses.component';
import { ClientStatusesComponent } from '../admin/client-statuses/client-statuses.component';
import { IncomesComponent } from '../admin/incomes/incomes.component';
import { PaymentTypesComponent } from '../admin/payment-types/payment-types.component';
import { ProductTypesComponent } from '../admin/product-types/product-types.component';
import { WorkStatusesComponent } from '../admin/work-statuses/work-statuses.component';
import { PolicyStatusesComponent } from '../admin/policy-statuses/policy-statuses.component';
import { BranchOfficesComponent } from '../admin/branch-offices/branch-offices.component';
import { ProductRolesComponent } from '../admin/product-roles/product-roles.component';
import { RolesComponent } from '../admin/roles/roles.component';
import { UsersComponent } from '../admin/users/users.component';
import { OccupationsComponent } from '../admin/occupations/occupations.component';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { SignaturePadModule } from 'angular2-signaturepad';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbDatepickerModule, NgbModalModule, NgbPaginationModule, NgbTabsetModule, NgbTimepickerModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';


@NgModule({
  imports: [
    CommonModule,
    AdminPanelRoutingModule,
    HttpClientModule,
    NgbDatepickerModule,
    NgbModalModule,
    NgbTabsetModule,
    NgbPaginationModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    FormsModule,
    SignaturePadModule,
    NgMultiSelectDropDownModule.forRoot(),
    LoadingBarHttpClientModule
  ],
  declarations: [
    UsersComponent,
    OccupationsComponent,
    BanksComponent,
    AppointmentStatusesComponent,
    ClientStatusesComponent,
    WorkStatusesComponent,
    IncomesComponent,
    PolicyStatusesComponent,
    ProductTypesComponent,
    PaymentTypesComponent,
    BranchOfficesComponent,
    ProductRolesComponent,
    RolesComponent
  ]
})
export class AdminPanelModule { }
